import { render, staticRenderFns } from "./SubprojectPanel.vue?vue&type=template&id=45b804be&scoped=true&lang=pug&"
import script from "./SubprojectPanel.vue?vue&type=script&lang=js&"
export * from "./SubprojectPanel.vue?vue&type=script&lang=js&"
import style0 from "./SubprojectPanel.vue?vue&type=style&index=0&id=45b804be&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b804be",
  null
  
)

export default component.exports